'use client';
import { createStyles, getSize, unit, keyframes, rem } from '@s7/styles';
import { objectEntries } from '@s7/utils';
import { getElementVariantStyles } from '../utils/Elements/getElementVariantStyles.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const processingAnimation = (color)=>keyframes({
        from: {
            boxShadow: `0 0 ${rem(1)} 0 ${color}`,
            opacity: 0.6
        },
        to: {
            boxShadow: `0 0 ${rem(1)} ${rem(6)} ${color}`,
            opacity: 0
        }
    });
const getPositionStyles = (_position, offset = 0)=>{
    if (_position === 'none') {
        return {};
    }
    const styles = {
        position: 'absolute'
    };
    const [position, placement] = _position.split('-');
    let translateX = '';
    let translateY = '';
    if (position === 'top') {
        styles.top = offset;
        translateY = '-50%';
    }
    if (position === 'middle') {
        styles.top = '50%';
        translateY = '-50%';
    }
    if (position === 'bottom') {
        styles.bottom = offset;
        translateY = '50%';
    }
    if (placement === 'start') {
        styles.left = offset;
        translateX = '-50%';
    }
    if (placement === 'center') {
        styles.left = '50%';
        translateX = '-50%';
    }
    if (placement === 'end') {
        styles.right = offset;
        translateX = '50%';
    }
    styles.transform = `translate(${translateX}, ${translateY})`;
    return styles;
};
var useStyles = createStyles((theme, params, variations)=>{
    const { radius, position, offset, inline, withBorder, withIcon, withLabel, zIndex, animate } = params;
    const { size, variant } = variations;
    const height = getSize({
        size,
        sizes: Object.fromEntries(objectEntries(theme.typography.default.sizes).map(([key, value])=>[
                key,
                value[1]
            ]))
    });
    const unitHeight = unit(height);
    const halfSize = unitHeight / 2;
    const { background, text } = getElementVariantStyles(theme, params, variations);
    const borderRadius = theme.fn.borderRadius(radius);
    return {
        wrapper: {
            position: 'relative',
            display: inline ? 'inline-block' : 'block',
            width: 'fit-content'
        },
        root: _extends({
            zIndex
        }, getPositionStyles(position, offset), {
            borderRadius,
            height
        }, !withLabel && {
            width: height
        }, theme.fn.typography({
            weight: 'medium',
            color: text,
            size
        }), {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxSizing: 'content-box',
            background,
            gap: theme.fn.space('1s'),
            whiteSpace: 'nowrap'
        }, withBorder && theme.fn.border({
            width: 2,
            color: theme.palette.background.content
        }), withLabel && {
            padding: theme.fn.space('0 2s')
        }, variant === 'dot' && _extends({
            padding: 0,
            background: 'none',
            border: 'none'
        }, theme.fn.typography({
            weight: 'regular',
            color: theme.palette.text.primary,
            size
        })), {
            '&::before': {
                content: animate ? '""' : undefined,
                width: variant === 'dot' ? halfSize : '100%',
                height: variant === 'dot' ? halfSize : '100%',
                position: 'absolute',
                borderRadius,
                animation: `${processingAnimation(background)} 1000ms linear infinite`
            }
        }),
        icon: _extends({
            display: 'none'
        }, variant === 'dot' && _extends({
            background: withIcon ? 'none' : background,
            borderRadius,
            height: halfSize,
            width: halfSize,
            display: 'flex'
        }, withBorder && theme.fn.border({
            width: 2,
            color: theme.palette.background.content
        }), {
            '& > svg': {
                width: '100%',
                height: '100%'
            }
        })),
        label: _extends({}, variant === 'dot' && position !== 'none' && _extends({
            position: 'absolute'
        }, position.endsWith('start') ? {
            right: halfSize + 8
        } : {
            left: halfSize + 8
        }))
    };
});

export { useStyles as default };
//# sourceMappingURL=Badge.styles.js.map
